import { InjectionToken } from '@angular/core';

export type BalanceTone = 'good' | 'amber' | 'red' | 'blue';
export interface BalanceLimit { id: string; direction: 'above' | 'below'; minutes: number; label: string; tone: BalanceTone; }
export interface BalanceRules { below: number; above: number; extra: BalanceLimit[]; }
export const DEFAULT_BALANCE_RULES: BalanceRules = { below: 30, above: 30, extra: [] };
export const BALANCE_RULES = new InjectionToken<() => BalanceRules>('BALANCE_RULES', { providedIn: 'root', factory: () => () => DEFAULT_BALANCE_RULES });
export function validateBalanceRules(rules: BalanceRules): string | null {
    const minutes = (n: unknown) => typeof n === 'number' && Number.isSafeInteger(n) && n >= 0 && n <= 1440;
    if (!rules || !minutes(rules.below) || !minutes(rules.above) || !Array.isArray(rules.extra)) return 'Bitte ganze Minuten zwischen 0 und 1440 angeben.';
    const seen = new Set<string>();
    for (const rule of rules.extra) {
        if (!rule || !['above', 'below'].includes(rule.direction) || !minutes(rule.minutes) || typeof rule.label !== 'string' || !rule.label.trim() || rule.label.length > 80 || !['good', 'amber', 'red', 'blue'].includes(rule.tone)) return 'Jede zusätzliche Grenze benötigt gültige Minuten, eine Bezeichnung (max. 80 Zeichen) und eine Farbe.';
        if (rule.minutes <= (rule.direction === 'above' ? rules.above : rules.below)) return 'Zusätzliche Grenzen müssen außerhalb des Bereichs „Eintrag in Ordnung“ liegen.';
        const key = rule.direction + rule.minutes;
        if (seen.has(key)) return 'Eine Grenze darf je Richtung nur einmal vorkommen.';
        seen.add(key);
    }
    return null;
}
export function balanceStatus(actual: number, planned: number, rules: BalanceRules): { label: string; tone: BalanceTone } {
    if (!Number.isFinite(actual) || !Number.isFinite(planned)) return { label: 'Keine Bewertung', tone: 'blue' };
    const delta = actual - planned;
    const direction = delta < -rules.below ? 'below' : delta > rules.above ? 'above' : null;
    if (!direction) return { label: 'Eintrag in Ordnung', tone: 'blue' };
    const extra = rules.extra.filter(r => r.direction === direction && Math.abs(delta) > r.minutes).sort((a,b) => b.minutes - a.minutes)[0];
    return extra ? { label: extra.label, tone: extra.tone } : direction === 'above'
        ? { label: 'Überstunden aufgebaut', tone: 'good' }
        : { label: 'Sollzeit nicht erreicht', tone: 'amber' };
}
